module.exports = __webpack_public_path__ + "img/23.399aa034.png";